import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"22px"} }
const _hoisted_2 = { style: {"font-weight":"bold","text-align":"left","font-size":"20px","margin-bottom":"15px","color":"#121619"} }
const _hoisted_3 = { style: {"font-size":"14px","color":"#697077","line-height":"19px"} }
const _hoisted_4 = { style: {"margin-bottom":"23px","font-size":"14px","color":"#697077","line-height":"19px"} }
const _hoisted_5 = ["innerHTML"]

import { ref, computed } from 'vue';
import { date } from 'xrk-tools';
import { useRoute } from 'vue-router';
import { getCommonProtocol } from '../data-source/api';

export default /*#__PURE__*/_defineComponent({
  __name: 'agree',
  setup(__props) {

const route = useRoute();

const title = ref(); //标题
const takeEffectAt = ref(); //生效日期
const releaseAt = ref(); //更新日期
const content = ref(); //内容

const type = computed(() => +route.query.type - 1);
const getAgree = async () => {
  const { data } = await getCommonProtocol(+route.query.platformUser);
  title.value = data[type.value].title;
  content.value = data[type.value].content;
  takeEffectAt.value = data[type.value].takeEffectAt;
  releaseAt.value = data[type.value].releaseAt;
};
getAgree();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1),
    _createElementVNode("div", _hoisted_3, " 更新日期：" + _toDisplayString(_unref(date).dateFormat(releaseAt.value, 'Y-M-D')), 1),
    _createElementVNode("div", _hoisted_4, " 生效日期：" + _toDisplayString(_unref(date).dateFormat(takeEffectAt.value, 'Y-M-D')), 1),
    _createElementVNode("p", {
      innerHTML: content.value,
      style: {"word-break":"break-all","font-size":"14px","color":"#121619","line-height":"19px"}
    }, null, 8, _hoisted_5)
  ]))
}
}

})